// Browser-safe theme config for runtime imports (e.g., deck.gl map colors).
// The full tailwind.config.js uses require() and CJS which can't be imported in Vite.
export default {
  theme: {
    colors: {
      black: "#000000",
      blue: {
        50: "#b4deff",
        100: "#0072CE",
        200: "#004EA8",
        300: "#002F6C",
        400: "#00263E",
        500: "#041A3C",
      },
      grey: {
        100: "#C1C6C8",
        200: "#5B6770",
        300: "#333F48",
      },
      green: {
        100: "#55B838",
        200: "#3fab83",
        300: "#20d18a",
      },
      mapColorRamp: {
        100: "#191970",
        200: "#005EB8",
        300: "#ffd027",
        400: "#00873E",
        500: "#e31a1c",
      },
      orange: "#fcae1e",
    },
  },
};
